/**
 * Dashboard, Home and Ask share instance health, live counts and the
 * ask latency targets, from one process-wide cached read (PRD-0271 D-2).
 *
 * Refetches on window focus and on the Socket.IO ticks useHomeLiveRealtime
 * drives; no polling loop. `retry: false` matches the read's own short TTL —
 * a failed fetch is left for the consumer to handle until focus or a live
 * event refreshes it.
 *
 * @module hooks/useHomeLive
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { api } from '@/services/api'
import type { HomeLiveResponse } from '@/types/home'

export const HOME_LIVE_QUERY_KEY = ['home', 'live'] as const

export function useHomeLive(): UseQueryResult<HomeLiveResponse> {
  return useQuery({
    queryKey: HOME_LIVE_QUERY_KEY,
    queryFn: api.home.live,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    retry: false,
  })
}
